export default {"src":"/_next/static/media/notifier-pic.b033e6bf.PNG","height":947,"width":1896,"blurWidth":0,"blurHeight":0};